import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight, MessageCircle } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-24 text-center">
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="mx-auto w-16 h-16 rounded-2xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center"
      >
        <CheckCircle2 className="w-8 h-8 text-emerald-500" />
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="font-display mt-6 text-4xl sm:text-5xl font-semibold tracking-tighter"
      >
        Thank you.
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.15 }}
        className="mt-4 text-muted-foreground text-lg"
      >
        Our team will reach out to you shortly with your personalized improvement plan.
        In the meantime, act on your top 3 recommendations from the report.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.25 }}
        className="mt-10 flex flex-col sm:flex-row justify-center gap-3"
      >
        <Link
          to="/"
          data-testid="thankyou-home-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-medium hover:-translate-y-[1px] transition"
        >
          Back to home
          <ArrowRight className="w-4 h-4" />
        </Link>
        <a
          href="https://wa.me/919999999999"
          target="_blank"
          rel="noreferrer"
          data-testid="thankyou-whatsapp-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-border font-medium hover:bg-accent transition"
        >
          <MessageCircle className="w-4 h-4" />
          Talk to a mentor
        </a>
      </motion.div>
    </div>
  );
}
